import { DEFAULT_LANGUAGE, normalizeLanguage } from './languages';

const STORAGE_PREFIX = 'bistroadmin.displayLanguage.';

export function languageStorageKey(userKey) {
    return `${STORAGE_PREFIX}${userKey || 'anon'}`;
}

export function getSavedLanguage(userKey) {
    try {
        return normalizeLanguage(localStorage.getItem(languageStorageKey(userKey)));
    } catch (error) {
        return null;
    }
}

export function setSavedLanguage(userKey, code) {
    const language = normalizeLanguage(code) || DEFAULT_LANGUAGE;
    try {
        localStorage.setItem(languageStorageKey(userKey), language);
    } catch (error) {
        // Ignore quota / private-mode failures.
    }
    return language;
}
